import { TrpcClient } from 'src/appState/TrpcClient';
import { UsersState } from 'src/domains/players/state/UsersState';
import { Amount } from 'src_common/common/amount/Amount';
import { getSavedCards } from 'src_server/trpc/types/payments';
import { paysafeBillingInfoFieldsValidation } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/helpers/billingInfoFiledsValidation/paysafeBillingInfoFieldsValidation';

interface WithdrawPaysafeParamsType {
    trpcClient: TrpcClient;
    usersState: UsersState;
    amount: Amount;
    paymentMethod: getSavedCards.SavedCardInterfaceType;
}

export type WithdrawPaysafeResultType = 'success' | 'error';

export const withdrawPaysafe = async ({
    trpcClient,
    usersState,
    amount,
    paymentMethod,
}: WithdrawPaysafeParamsType): Promise<WithdrawPaysafeResultType> => {
    const customer = await usersState.basicData.fetch();
    const billingInfo = paysafeBillingInfoFieldsValidation(customer);

    if (billingInfo?.type === 'error' || billingInfo?.data === undefined) {
        return 'error';
    }

    const date = new Date().toUTCString();
    const withdrawalResponse = await trpcClient.client.paysafeRouter.withdrawalsPaysafe.mutate({
        merchantRefNum: `${billingInfo.data.merchantCustomerId.toString()}-${date}`,
        amount: amount.value,
        currencyCode: billingInfo.data.currency,
        paymentHandleToken: paymentMethod.providerReference ?? '',
        description: 'Withdrawal',
        paymentMethod,
    });

    if (withdrawalResponse.responseStatus === 'error') {
        return 'error';
    }

    return 'success';
};
